module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-fi.e6ef461dcf85a18f0553.svg";